<template>
    <div>
        <div v-bind:class="wrapClass" style="width:100%; margin:0px;" v-bind:style="{height:isVertical?'70px':'35px'}">
            <span class="input-group-addon" v-if="!isVertical && hasLable && isFrontLabel">
            <i class="zmdi" v-bind:class="icon" v-if="hasIcon"></i><span class="gray" v-bind:class="{'p-10':hasIcon}">{{label}}</span>
            </span>
            <div class="fg-line" v-bind:class="{'fg-toggled':hasValue}">
                <select v-bind:class="selectClass[stype]" data-placeholder="placeholder" v-bind:disabled="!isEnabled"
                        v-bind:multiple="multiple">
                    <option v-if="hasEmpty"></option>
                    <option v-for="item in source" v-bind:value="_p_getItemValue(item)">{{_p_getItemText(item)}}
                    </option>
                </select>
                <label class="fg-label" style="margin-top: -22px;overflow: hidden" v-if="isVertical">{{label}} </label>
            </div>
            <span class="input-group-addon" v-if="!isVertical && hasLable && !isFrontLabel">
            <i class="zmdi" v-bind:class="icon" v-if="hasIcon"></i><span class="gray" v-bind:class="{'p-10':hasIcon}">{{label}}</span>
            </span>
            <div v-if="validator">
                <span class="zmdi zmdi-alert-triangle form-control-feedback" v-show="!Valid_Status__"
                      data-placement="bottom" style="width:5px;"></span>
                <span class="zmdi zmdi-check form-control-feedback" v-if="Valid_Status__ && hasValueLength"
                      style="width:5px;"></span>
            </div>
        </div>
    </div>
</template>

<script>

    import mixins from '../../mixins/control-mixins';
    import valid from '../../mixins/control-valid';
    import expression from 'helpers/expression';
    import 'jquery.boostrap.select';
    import 'jquery.boostrap.select.language';
    var data = function () {
        return {
            controlType: 'select',
            ifocus: false,
            currentItem: {},
            selectClass: {
                selectpicker: 'selectpicker'
            },
            expressionSrc: new expression(),
            isInit: false,
            oldValue: '',
            myvalue: null
        };
    };
    export default {
        name: 'c-select',
        mixins: [mixins, valid],
        data: data,
        computed: {
            hasValue: function () {
                var vm = this;
                var flag = this.ifocus || vm.myvalue || vm.myvalue === 0 ||
                    (vm.myvalue && vm.myvalue.toString().length > 0 && this.isVertical);
                return flag;
            },
            wrapClass() {
                return {
                    'disabled': !this.isEnabled,
                    'input-group': !this.isVertical,
                    'form-group fg-float p-t-20': this.isVertical,
                    'has-warning': this.validator && !this.Valid_Status__,
                    'has-success': this.validator && this.Valid_Status__
                }
            },
            hasIcon() {
                return this.icon && this.icon.length > 0;
            },
            hasLable() {
                return this.label && this.label.length > 0;
            },
            hasValueLength() {
                return this.value && this.value.length > 0;
            }
        },
        props: {
            stype: {
                type: String,
                coerce: function (val) {
                    var resultType = 'selectpicker';
                    var selectType = ['selectpicker'];
                    for (var i = 0; i < selectType.length; i++) {
                        if (selectType[i] === val) {
                            resultType = selectType[i];
                            break;
                        }
                    }
                    return resultType;
                },
                default: function () {
                    return 'selectpicker';
                }
            },
            exdata: {
                type: String,
                default: function () {
                    return '';
                }
            },

            multiple: {
                type: Boolean,
                default: function () {
                    return false;
                }
            },
            hasEmpty: {
                type: Boolean,
                default: function () {
                    return true;
                }
            },
            value: {
                required: true,
                default: function () {
                    return '';
                }
            },
            source: {
                type: [Array],
                default: function () {
                    return [];
                }
            },
            svalue: {
                type: String,
                default: function () {
                    return 'value';
                }
            },
            stext: {
                type: String,
                default: function () {
                    return 'text';
                }
            }
        },
        mounted: function () {
            var vm = this;
            this.$nextTick(function () {
                vm.init();
                if (vm.source && vm.source.length > 0) {
                    vm.setValue(vm.value);
                }
            });
        },
        methods: {
            init: function () {
                if (!this.isInit) {
                    var vm = this;
                    $(vm.$el).find('.selectpicker').selectpicker().on('changed.bs.select', function (e,
                                                                                                     i, newValue,
                                                                                                     oldValue) {
                        vm._p_changeValue(e);
                    }).on('refreshed.bs.select', function () {
                        vm.setValue(vm.value);
                    });
                }

                this.isInit = true;
            },
            getInstance: function () {
                var vm = this;
                if (!vm.instance) {
                    if (!vm.isInit) {
                        vm.init();
                    }
                    vm.instance = $(vm.$el).find('.selectpicker').data('selectpicker');
                }
                return vm.instance;
            },
            setValue: function (val) {
                //设置值，统一转为callback调用
                var vm = this;

                vm.updateValue(val);
                vm.currentItem = vm.getSelectedItems();
                if (vm.oldValue === vm.myvalue)
                    return;
                else
                    vm.oldValue = vm.myvalue;
                //由于change事件应该是手选才触发，所以现在不再写到这里，改为写_p_change
                //vm.$emit('change', vm.myvalue, vm.currentItem);
                //vm.mid_codeChangeValue(val, vm.updateValue);
            },
            updateValue: function (val) {
                var vm = this;

                vm.getInstance().val(val);
                //vm._p_changeValue();

                vm.myvalue = val;
                vm.doValid();
            },
            refresh: function () {
                var vm = this;
                vm.$nextTick(function () {

                    vm.getInstance().refresh();

                });
            },
            _p_focus: function (e) {
                this.ifocus = true;
                this.$emit('focus', arguments);
            },
            _p_blur: function (e) {
                this.ifocus = false;
                this.$emit('blur', arguments);
            },
            /**
             * 根据传入的item，使用语法逻辑分析绑定option值
             * @param {} item
             * @returns {}
             */
            _p_getItemValue: function (item) {
                var vm = this;
                var value = vm.expressionSrc.getvalue(item, vm.svalue);
                if (value === null)
                    return '__null';
                else if (value === undefined)
                    return '__undefined';
                else
                    return value;
            },
            /**
             * 根据传入的item，使用语法逻辑分析绑定显示文本
             * @param {} item
             * @returns {}
             */
            _p_getItemText: function (item) {
                var vm = this;
                var value = vm.expressionSrc.getvalue(item, vm.stext);
                if (value === null)
                    return '__null';
                else if (value === undefined)
                    return '__undefined';
                else
                    return value;
            },
            /**
             * 下拉框改变值，绑定真实值到value，同时提供currentItem对象
             * @param {} e
             * @returns {}
             */
            _p_changeValue: function (e) {
                var vm = this;
                var isMatch = false;
                var val = $(vm.$el).find('select').val();
                if (vm.multiple) {
                    /*多选逻辑*/
                    vm.currentItem = [];
                    if (val instanceof Array) {
                        vm.myvalue = [];
                        for (var j = 0; j < val.length; j++) {
                            for (var i = 0; i < vm.source.length; i++) {
                                var value = vm._p_getItemValue(vm.source[i]);
                                if (value == val[j]) {
                                    //if (!isInit) {
                                    //    vm.myvalue = [];
                                    //    isInit = true;
                                    //}

                                    vm.myvalue.push(value);
                                    vm.currentItem.push(vm.source[i]);
                                    isMatch = true;
                                    break;
                                }
                            }
                        }
                    } else if (!val) {
                        vm.myvalue = [];
                    } else {
                        val = vm.myvalue;
                    }
                } else {
                    /**
                     * 单选逻辑
                     */
                    for (var i = 0; i < vm.source.length; i++) {
                        var value = vm._p_getItemValue(vm.source[i]);
                        if (value == val) {
                            vm.myvalue = value;
                            vm.currentItem = vm.source[i];
                            isMatch = true;
                            break;
                        }
                    }
                }
                if (!isMatch) {
                    vm.myvalue = val;
                    vm.currentItem = [];
                }
                vm.$nextTick(function () {
                    vm.$emit('change', vm.myvalue, vm.currentItem);
                });
            },
            getSelectedItems: function () {
                var vm = this;
                var currentItem = [];
                if (vm.myvalue instanceof Array) {
                    for (var j = 0; j < vm.myvalue.length; j++) {
                        for (let i = 0; i < vm.source.length; i++) {
                            let value = vm._p_getItemValue(vm.source[i]);
                            if (value == vm.myvalue[j]) {
                                currentItem.push(vm.source[i]);
                                break;
                            }
                        }
                    }
                } else {
                    for (let i = 0; i < vm.source.length; i++) {
                        let value = vm._p_getItemValue(vm.source[i]);
                        if (value == vm.myvalue) {
                            currentItem = vm.source[i];
                            break;
                        }
                    }
                }
                return currentItem;
            }
        },
        watch: {
            'source': function () {
                var vm = this;
                this.refresh();
                //if (vm.multiple)
                //    vm.myvalue = [];
                //else
                //    vm.myvalue = null;
                //vm.setValue(vm.value);
            },
            'value': function (val) {
                var vm = this;
                vm.setValue(val);
            },
            'isEnabled': function () {
                this.refresh();
            },
            'myvalue': function (value) {
                this.$emit('input', value);
            }
        }
    };

</script>




// WEBPACK FOOTER //
// select.vue?0686ac32